<script>
import { mapGetters } from 'vuex'
import Filter from './Filter'
import Roles from '@/mixins/Roles'
export default {
    mixins: [Roles],

    data() {
        return {
            per_page: 10,
        }
    },

    computed: mapGetters({
        cars: 'cars',
        search: 'search',
        filters: 'filters',
    }),

    watch: {
        search: 'page',
        filters: 'page',
    },

    mounted() {
        this.page(1)
        this.$store.dispatch('filterComponent', Filter)
    },

    methods: {
        page(n) {
            this.$store.dispatch('carsFetchList', {
                page: n,
                per_page: this.per_page,
                search: this.search,
                filters: this.filters,
            })
        },
    },
}
</script>

<template lang="pug">
acrm-panel
    template(slot="heading")
        acrm-heading.mr-2.mb-0(:level="3") {{ $t('CARS.CARS') }}
        span {{ $t('CARS.NUM_CARS', { num: cars && cars.meta && cars.meta.total ? cars.meta.total : 0 })}}
        acrm-input-button.ml-auto.block-xs.mt-2.mt-sm-0(
            v-if="hasRoleUpdate('masterdata.cars')"
            @click="$router.push({name: 'cars-create'})") {{ $t('CARS.NEW') }}

    template(v-if="cars && cars.data && cars.meta && cars.meta.current_page != undefined")
        table.table.table-striped.table-hover()
            thead
            tbody
                tr(v-for="car in cars.data" :key="car.id")
                    td
                        .row
                            .col
                                .flex-center-v.mb-2
                                    acrm-badge.mr-2(icon="directions_car")
                                    router-link(:to="{name: 'cars-view', params: { car: car.id }}")
                                        acrm-heading.mb-0(:level="6") {{ car.type }}
                                .d-flex.flex-wrap
                                    .flex-center-v.mr-4.mt-2.mt-lg-0
                                        acrm-badge.px-2.py-1.mr-2(variant="light")
                                            icon(name="people")
                                            span.ml-2 {{ $t('USERS.NUM_USERS', { num: 0 }) }}
                                    .flex-center-v.mr-4.mt-2.mt-lg-0.flex-wrap
                                        acrm-heading.block-xs.mb-0.mr-2(:level="6") {{ $t('BASE.BASEDATA') }}:
                                        span.mr-2 {{ car.license }}
                                        span {{ car.color }}
    acrm-paginate(:data="cars.meta" @page="page")
</template>
